import { useEffect, useCallback } from 'react'
import { on, off } from '@/apis/qwebApi'
// window.emit = emit
const Hook = (onOpenDetail) => {
  // 更新回调
  const onOpenDetailPage = useCallback(
    (app) => {
      onOpenDetail && onOpenDetail(app)
    },
    [onOpenDetail]
  )
  useEffect(() => {
    on('openDetailPage', onOpenDetailPage)
    return () => {
      off('openDetailPage', onOpenDetailPage)
    }
  }, [onOpenDetailPage])
}

export default Hook
